// Hoffman Institute's Comprehensive Emotion & Body Sensation Model

export const HOFFMAN_CATEGORIES = {
  'Accepting/Open': {
    color: '#81C784',
    valence: 0.7,
    feelings: ['Calm', 'Centered', 'Content', 'Fulfilled', 'Patient', 'Peaceful', 'Present', 'Relaxed', 'Serene', 'Trusting']
  },
  'Aliveness/Joy': {
    color: '#FFD54F',
    valence: 0.9,
    feelings: ['Amazed', 'Awe', 'Bliss', 'Delighted', 'Eager', 'Ecstatic', 'Enchanted', 'Energized', 'Engaged', 'Enthusiastic', 'Excited', 'Free', 'Happy', 'Inspired', 'Invigorated', 'Lively', 'Passionate', 'Playful', 'Radiant', 'Refreshed', 'Rejuvenated', 'Renewed', 'Satisfied', 'Thrilled', 'Vibrant']
  },
  'Angry/Annoyed': {
    color: '#E57373',
    valence: -0.7,
    feelings: ['Agitated', 'Aggravated', 'Bitter', 'Contempt', 'Cynical', 'Disdain', 'Disgruntled', 'Disturbed', 'Edgy', 'Exasperated', 'Frustrated', 'Furious', 'Grouchy', 'Hostile', 'Impatient', 'Irritated', 'Irate', 'Moody', 'On edge', 'Outraged', 'Pissed', 'Resentful', 'Upset', 'Vindictive']
  },
  'Connected/Loving': {
    color: '#F06292',
    valence: 0.8,
    feelings: ['Accepting', 'Affectionate', 'Caring', 'Compassion', 'Empathy', 'Fulfilled', 'Present', 'Safe', 'Warm', 'Worthy']
  },
  'Curious': {
    color: '#4FC3F7',
    valence: 0.6,
    feelings: ['Engaged', 'Exploring', 'Fascinated', 'Interested', 'Intrigued', 'Involved', 'Stimulated']
  },
  'Despair/Sad': {
    color: '#90A4AE',
    valence: -0.8,
    feelings: ['Anguish', 'Depressed', 'Despondent', 'Disappointed', 'Discouraged', 'Forlorn', 'Gloomy', 'Grief', 'Heartbroken', 'Hopeless', 'Lonely', 'Longing', 'Melancholy', 'Sorrow', 'Teary', 'Unhappy', 'Upset', 'Weary', 'Yearning']
  },
  'Disconnected/Numb': {
    color: '#B0BEC5',
    valence: -0.4,
    feelings: ['Aloof', 'Bored', 'Confused', 'Distant', 'Empty', 'Indifferent', 'Isolated', 'Lethargic', 'Listless', 'Removed', 'Resistant', 'Shut Down', 'Uneasy', 'Withdrawn']
  },
  'Embarrassed/Shame': {
    color: '#FFAB91',
    valence: -0.6,
    feelings: ['Ashamed', 'Humiliated', 'Inhibited', 'Mortified', 'Self-conscious', 'Useless', 'Weak', 'Worthless']
  },
  'Fear': {
    color: '#9575CD',
    valence: -0.7,
    feelings: ['Afraid', 'Anxious', 'Apprehensive', 'Frightened', 'Hesitant', 'Nervous', 'Panic', 'Paralyzed', 'Scared', 'Terrified', 'Worried']
  },
  'Fragile': {
    color: '#F8BBD0',
    valence: -0.3,
    feelings: ['Helpless', 'Sensitive']
  },
  'Grateful': {
    color: '#AED581',
    valence: 0.8,
    feelings: ['Appreciative', 'Blessed', 'Delighted', 'Fortunate', 'Grace', 'Humbled', 'Lucky', 'Moved', 'Thankful', 'Touched']
  },
  'Guilt': {
    color: '#A1887F',
    valence: -0.5,
    feelings: ['Regret', 'Remorseful', 'Sorry']
  },
  'Hopeful': {
    color: '#80DEEA',
    valence: 0.7,
    feelings: ['Encouraged', 'Expectant', 'Optimistic', 'Trusting']
  },
  'Powerless': {
    color: '#BCAAA4',
    valence: -0.6,
    feelings: ['Impotent', 'Incapable', 'Resigned', 'Trapped', 'Victim']
  },
  'Courageous/Powerful': {
    color: '#FFB74D',
    valence: 0.8,
    feelings: ['Adventurous', 'Brave', 'Capable', 'Confident', 'Daring', 'Determined', 'Free', 'Grounded', 'Proud', 'Strong', 'Worthy', 'Valiant']
  },
  'Stressed/Tense': {
    color: '#EF5350',
    valence: -0.7,
    feelings: ['Anxious', 'Burned out', 'Cranky', 'Depleted', 'Edgy', 'Exhausted', 'Frazzled', 'Overwhelm', 'Rattled', 'Rejecting', 'Restless', 'Shaken', 'Tight', 'Weary', 'Worn out']
  },
  'Tender': {
    color: '#CE93D8',
    valence: 0.6,
    feelings: ['Calm', 'Caring', 'Loving', 'Reflective', 'Self-loving', 'Serene', 'Vulnerable', 'Warm']
  },
  'Unsettled/Doubt': {
    color: '#FFB74D',
    valence: -0.4,
    feelings: ['Apprehensive', 'Concerned', 'Dissatisfied', 'Disturbed', 'Grouchy', 'Hesitant', 'Inhibited', 'Perplexed', 'Questioning', 'Rejecting', 'Reluctant', 'Shocked', 'Skeptical', 'Suspicious', 'Ungrounded', 'Unsure', 'Worried']
  }
};

export const BODY_SENSATIONS = [
  'Achy', 'Airy', 'Blocked', 'Breathless', 'Bruised', 'Burning', 'Buzzy', 'Clammy', 
  'Clenched', 'Cold', 'Constricted', 'Contained', 'Contracted', 'Dizzy', 'Drained', 
  'Dull', 'Electric', 'Empty', 'Expanded', 'Flowing', 'Fluid', 'Fluttery', 'Frozen', 
  'Full', 'Gentle', 'Hard', 'Heavy', 'Hollow', 'Hot', 'Icy', 'Itchy', 'Jumpy', 
  'Knotted', 'Light', 'Loose', 'Nauseous', 'Numb', 'Pain', 'Pounding', 'Prickly', 
  'Pulsing', 'Queasy', 'Radiating', 'Relaxed', 'Releasing', 'Rigid', 'Sensitive', 
  'Settled', 'Shaky', 'Shivery', 'Slow', 'Smooth', 'Soft', 'Sore', 'Spacey', 
  'Spacious', 'Sparkly', 'Stiff', 'Still', 'Suffocated', 'Sweaty', 'Tender', 
  'Tense', 'Throbbing', 'Tight', 'Tingling', 'Trembly', 'Twitchy', 'Vibrating', 
  'Warm', 'Wobbly', 'Wooden'
];

// Body regions for interactive diagram
export const BODY_REGIONS = {
  head: { label: 'Head/Face', x: 50, y: 10, defaultSensations: ['Dizzy', 'Pounding', 'Tight', 'Hot', 'Spacey'] },
  throat: { label: 'Throat/Neck', x: 50, y: 20, defaultSensations: ['Tight', 'Clenched', 'Constricted', 'Blocked', 'Choked'] },
  chest: { label: 'Chest/Heart', x: 50, y: 35, defaultSensations: ['Tight', 'Heavy', 'Pounding', 'Expanded', 'Warm', 'Hollow'] },
  stomach: { label: 'Stomach/Gut', x: 50, y: 50, defaultSensations: ['Knotted', 'Butterflies', 'Nauseous', 'Tight', 'Empty', 'Full'] },
  pelvis: { label: 'Pelvis/Lower Belly', x: 50, y: 62, defaultSensations: ['Tight', 'Heavy', 'Tense', 'Relaxed'] },
  arms: { label: 'Arms/Hands', x: 25, y: 45, defaultSensations: ['Tense', 'Shaky', 'Tingling', 'Heavy', 'Light'] },
  legs: { label: 'Legs/Feet', x: 50, y: 80, defaultSensations: ['Heavy', 'Weak', 'Shaky', 'Tense', 'Grounded'] },
  shoulders: { label: 'Shoulders/Upper Back', x: 50, y: 28, defaultSensations: ['Tight', 'Tense', 'Heavy', 'Stiff', 'Relaxed'] },
  wholebody: { label: 'Whole Body', x: 50, y: 50, defaultSensations: ['Hot', 'Cold', 'Tense', 'Relaxed', 'Energy', 'Drained'] }
};

// Get category by name
export const getHoffmanCategory = (categoryName) => {
  return HOFFMAN_CATEGORIES[categoryName] || null;
};

// Get all category names
export const getCategoryNames = () => {
  return Object.keys(HOFFMAN_CATEGORIES);
};

// Check if feeling is positive or negative based on valence
export const isPositiveFeeling = (categoryName) => {
  const category = HOFFMAN_CATEGORIES[categoryName];
  return category && category.valence > 0;
};

// Get music theme based on Hoffman category
export const getMusicForCategory = (categoryName) => {
  const musicMap = {
    'Accepting/Open': 'https://assets.mixkit.co/active_storage/sfx/2568/2568-preview.mp3',
    'Aliveness/Joy': 'https://assets.mixkit.co/active_storage/sfx/2570/2570-preview.mp3',
    'Angry/Annoyed': 'https://assets.mixkit.co/active_storage/sfx/2571/2571-preview.mp3',
    'Connected/Loving': 'https://assets.mixkit.co/active_storage/sfx/2568/2568-preview.mp3',
    'Curious': 'https://assets.mixkit.co/active_storage/sfx/2569/2569-preview.mp3',
    'Despair/Sad': 'https://assets.mixkit.co/active_storage/sfx/2577/2577-preview.mp3',
    'Disconnected/Numb': 'https://assets.mixkit.co/active_storage/sfx/2572/2572-preview.mp3',
    'Embarrassed/Shame': 'https://assets.mixkit.co/active_storage/sfx/2571/2571-preview.mp3',
    'Fear': 'https://assets.mixkit.co/active_storage/sfx/2571/2571-preview.mp3',
    'Fragile': 'https://assets.mixkit.co/active_storage/sfx/2571/2571-preview.mp3',
    'Grateful': 'https://assets.mixkit.co/active_storage/sfx/2568/2568-preview.mp3',
    'Guilt': 'https://assets.mixkit.co/active_storage/sfx/2577/2577-preview.mp3',
    'Hopeful': 'https://assets.mixkit.co/active_storage/sfx/2568/2568-preview.mp3',
    'Powerless': 'https://assets.mixkit.co/active_storage/sfx/2577/2577-preview.mp3',
    'Courageous/Powerful': 'https://assets.mixkit.co/active_storage/sfx/2570/2570-preview.mp3',
    'Stressed/Tense': 'https://assets.mixkit.co/active_storage/sfx/2571/2571-preview.mp3',
    'Tender': 'https://assets.mixkit.co/active_storage/sfx/2568/2568-preview.mp3',
    'Unsettled/Doubt': 'https://assets.mixkit.co/active_storage/sfx/2572/2572-preview.mp3'
  };
  return musicMap[categoryName] || musicMap['Accepting/Open'];
};
